import { Component, OnInit, OnDestroy } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NotificationService, AppNotification } from '../../providers/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'notifications-popover',
  template: `
    <ion-header>
      <ion-toolbar>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 0 10px;">
          <span style="font-size: 14px; font-weight: bold; white-space: nowrap;">Notifications</span>
          <ion-button color="danger" fill="clear" size="small" (click)="cleanAll()" style="text-transform: none; margin: 0;">
            Clean all
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-header>
    
    <ion-content>
      <div *ngIf="notifications.length === 0" style="text-align: center; padding: 20px; color: #999;">
        <ion-icon name="notifications-outline" style="font-size: 40px; color: #ccc; margin-bottom: 10px;"></ion-icon>
        <p style="margin: 0; font-size: 12px;">You have no new notifications</p>
      </div>

      <ion-list *ngIf="notifications.length > 0">
        <ion-item *ngFor="let n of notifications" (click)="markAsRead(n)" [style.background]="n.read_at ? '#fff' : '#f4f5f8'" button>
          <ion-icon [name]="(n.data && n.data.icon) ? n.data.icon : 'notifications'" slot="start" color="primary"></ion-icon>
          <ion-label class="ion-text-wrap">
            <h3 style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">{{ n.data ? n.data.title : '' }}</h3>
            <p style="font-size: 12px; color: #666;">{{ n.data ? n.data.message : '' }}</p>
            <p style="font-size: 10px; color: #999; margin-top: 5px;">{{ n.created_at | date:'short' }}</p>
          </ion-label>
          <ion-icon name="close" slot="end" color="medium" (click)="deleteNotif(n, $event)"></ion-icon>
        </ion-item>
      </ion-list>
    </ion-content>
  `,
  styles: [`
    ion-content {
      --background: #fff;
    }
  `]
})
export class NotificationsPopover implements OnInit, OnDestroy {
  notifications: AppNotification[] = [];
  private sub: Subscription;

  constructor(
    public popoverCtrl: PopoverController,
    private notifService: NotificationService
  ) {}

  ngOnInit() {
    this.sub = this.notifService.notifications$.subscribe(notifs => {
      this.notifications = notifs;
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  cleanAll() {
    this.notifService.deleteAll().subscribe(() => {
      this.popoverCtrl.dismiss();
    });
  }

  deleteNotif(n: AppNotification, event: Event) {
    event.stopPropagation();
    this.notifService.deleteNotification(n.id).subscribe();
  }

  markAsRead(n: AppNotification) {
    if (!n.read_at) {
      this.notifService.markAsRead(n.id).subscribe();
    }
    if (n.data && n.data.url && n.data.url !== '#') {
      this.popoverCtrl.dismiss({ url: n.data.url });
    }
  }
}
